var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1431_12499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "currentColor",
    clipRule: "evenodd",
    d: "M17.5013 14.9991C17.9615 14.9991 18.3346 15.3722 18.3346 15.8324C18.3346 16.2926 17.9615 16.6657 17.5013 16.6657H5.83464C5.3744 16.6657 5.0013 16.2926 5.0013 15.8324C5.0013 15.3722 5.3744 14.9991 5.83464 14.9991H17.5013ZM17.5013 9.16573C17.9615 9.16573 18.3346 9.53883 18.3346 9.99906C18.3346 10.4593 17.9615 10.8324 17.5013 10.8324H5.83464C5.3744 10.8324 5.0013 10.4593 5.0013 9.99906C5.0013 9.53883 5.3744 9.16573 5.83464 9.16573H17.5013ZM17.5013 3.3324C17.9615 3.3324 18.3346 3.70549 18.3346 4.16573C18.3346 4.62597 17.9615 4.99906 17.5013 4.99906H5.83464C5.3744 4.99906 5.0013 4.62597 5.0013 4.16573C5.0013 3.70549 5.3744 3.3324 5.83464 3.3324H17.5013ZM1.66797 3.3324H3.33464V4.99906H1.66797V3.3324ZM1.66797 9.16573H3.33464V10.8324H1.66797V9.16573ZM1.66797 14.9991H3.33464V16.6657H1.66797V14.9991Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1431_12499)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: -0.000976562,
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.891723da.svg";
export { ForwardRef as ReactComponent };